import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { X } from 'lucide-react';
import { getAccessDeviceInfo } from '@/lib/deviceInfo';
import { useIsMobile } from '@/hooks/use-mobile';

const APP_STORE_URL = 'https://apps.apple.com/us/app/jampackd/id6755335553';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.jampackd.store.jampack_d_mobile';

const MobileAppCtaNotice = () => {
  const [storeUrl, setStoreUrl] = useState<string | null>(null);
  const isMobile = useIsMobile();

  useEffect(() => {
    const info = getAccessDeviceInfo();

    if (info.surface !== 'mobile_browser') {
      return;
    }

    if (info.platform === 'ios') {
      setStoreUrl(APP_STORE_URL);
    } else if (info.platform === 'android') {
      setStoreUrl(PLAY_STORE_URL);
    }
  }, []);

  const handleDismiss = (e?: React.MouseEvent) => {
    e?.stopPropagation();
    setStoreUrl(null);
  };

  const handleClick = () => {
    if (storeUrl) {
      window.open(storeUrl, '_blank', 'noopener,noreferrer');
    }
  };

  if (!storeUrl) return null;

  const bottomOffset = isMobile ? 'bottom-24' : 'bottom-6';

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 16 }}
        transition={{ duration: 0.25, ease: 'easeOut' }}
        className={`fixed left-4 ${bottomOffset} z-[110] pointer-events-auto`}
        data-support-offset="raised"
      >
        <button
          onClick={handleClick}
          className="relative flex items-center gap-3 bg-black text-white rounded-full px-3 py-2 shadow-lg shadow-black/25 hover:shadow-black/30 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-white/30"
          style={{ minHeight: '44px' }}
        >
          <img
            src="/app-icon.png"
            alt="JamPackd app icon"
            className="w-8 h-8 rounded-lg object-cover"
          />
          <span className="text-sm font-semibold tracking-wide">
            CLICK TO GET OUR APP
          </span>
          <div
            onClick={handleDismiss}
            className="absolute -top-2 -right-2 w-5 h-5 bg-red-500 hover:bg-red-600 text-white rounded-full flex items-center justify-center shadow-md transition-colors duration-150 cursor-pointer"
            aria-label="Dismiss app notice"
          >
            <X className="w-3 h-3" />
          </div>
        </button>
      </motion.div>
    </AnimatePresence>
  );
};

export default MobileAppCtaNotice;
